import React from 'react';

interface StartButtonProps {
  callback: () => void;
}

// Button to start the game
const StartButton: React.FC<StartButtonProps> = ({ callback }) => (
  <button
    type="button"
    onClick={callback}
    className="start-button"
  >
    Start Game
  </button>
);

export default React.memo(StartButton);